<template>
  <div class="login_container">
    <div class="login_box">
      <!-- 头像区域 -->
      <div class="avatar_box">
        <img src="~@/assets/login/logo.png" alt="">
      </div>
      <!-- 登录表单区域 -->
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login_form">
        <!-- 用户名 -->
        <el-form-item prop="userAccount">
          <el-input
            v-model="loginForm.userAccount"
            prefix-icon="iconfont icon-user"
            clearable
            placeholder="请输入账号或邮箱">
          </el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            prefix-icon="iconfont icon-3702mima"
            type="password"
            clearable
            show-password
            placeholder="请输入密码">
          </el-input>
        </el-form-item>

        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button type="text" @click="openRegister" style="left: 0;">免费注册</el-button>
          <el-button type="primary" :loading="loginLoading" :disabled="loginLoading" @click="login">登录</el-button>
          <el-button type="info" @click="resetLoginForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- ICP备案号 -->
    <div class="icp-footer">
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
        粤ICP备2026058420号
      </a>
    </div>
  </div>
</template>

<script>
// 引入 jsencrypt 和 Base64 编码库
import JSEncrypt from 'jsencrypt'
// 需要安装 js-base64 库
import { Base64 } from 'js-base64'

export default {
  data() {
    // 自定义验证函数
    const validateUserAccount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入登录账号'))
        return
      }
      if (value.length < 2 || value.length > 18) {
        callback(new Error('账号长度必须为2-18位'))
        return
      }
      if (/^\d+$/.test(value)) {
        callback(new Error('账号不能全是数字'))
        return
      }
      // 允许中文、英文、数字、下划线、@、.
      if (!/^[\u4e00-\u9fa5a-zA-Z0-9_@.]+$/.test(value)) {
        callback(new Error('账号只能包含中文、英文、数字、下划线、@、.'))
        return
      }
      callback()
    }
    return {
      publicKey: null,
      loginLoading: false,
      loginForm: {
        userAccount: '',
        password: ''
      },
      loginFormRules: {
        userAccount: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { validator: validateUserAccount, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          // { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openRegister() {
      this.$router.push('/register')
    },

    async fetchPublicKey() {
      try {
        const { data } = await this.$http.get('/rsa/getPublicKey')
        this.publicKey = data
      } catch (error) {
        console.error('操作失败，请刷新重试:', error)
        this.$message.warning('操作失败，请刷新重试')
      }
    },

    async login() {
      this.loginLoading = true
      try {
        const valid = await new Promise((resolve) => {
          this.$refs.loginFormRef.validate((valid) => resolve(valid))
        })
        if (!valid) {
          this.loginLoading = false
          return
        }
        const formData = new FormData()
        formData.append('userAccount', this.loginForm.userAccount)
        const { data: result } = await this.$http.post('/user/getActive', formData)
        if (result.status === 200 && result.data && result.data.active === 0) {
          this.$message.warning('该账户尚未授权，请联系管理员!')
          this.loginLoading = false
          return
        }
        await this.fetchPublicKey()
        const encryptedPassword = this.encryptString(this.loginForm.password)
        const base64EncodedPassword = Base64.encode(encryptedPassword)
        const { data: loginResult } = await this.$http.post('/user/login', {
          userAccount: this.loginForm.userAccount,
          password: base64EncodedPassword
        })
        if (loginResult.status !== 200) {
          this.$message.warning(loginResult.message)
          this.loginLoading = false
          return
        }
        // 先存储用户基本信息（包括 token）
        const roleId = parseInt(loginResult.data.role, 10)
        this.$store.dispatch('globalUserInfo/login', {
          token: 'Bearer ' + loginResult.data.token,
          userId: loginResult.data.userId,
          userAccount: loginResult.data.userAccount,
          roleId: roleId,
          roleName: ''
        })
        // 等待 token 设置完成
        await this.$nextTick()
        // 现在请求角色列表（此时 token 已经在请求头中）
        let roleName = ''
        try {
          const { data: roleResult } = await this.$http.get('/role/list')
          if (roleResult.success && roleResult.data) {
            const role = roleResult.data.find(r => Number(r.roleId) === roleId)
            roleName = role ? role.roleName : '未知'
          }
        } catch (error) {
          console.error('获取角色列表失败:', error)
          roleName = '未知'
        }
        // 更新 roleName
        this.$store.dispatch('globalUserInfo/updateUserInfo', {
          roleName: roleName
        })
        this.$router.push({ path: '/home' })
      } catch (error) {
        console.error('登录请求失败:', error)
        this.$message.warning('登录失败，请稍后再试')
      } finally {
        this.loginLoading = false
      }
    },

    resetLoginForm() {
      this.loginForm.userAccount = ''
      this.loginForm.password = ''
    },

    encryptString(str) {
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(this.publicKey)
      return encrypt.encrypt(str)
    }
  }
}
</script>

<style lang="less" scoped>
.login_container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  /* 渐变背景 - 深蓝色到深紫色 */
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 25%, #0f3460 50%, #1a1a2e 75%, #16213e 100%);
  background-size: 200% 200%;
  animation: gradientShift 10s ease infinite;
}

/* 动态粒子效果 */
.login_container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    radial-gradient(circle at 20% 40%, rgba(64, 158, 255, 0.15) 1px, transparent 1px),
    radial-gradient(circle at 80% 70%, rgba(64, 158, 255, 0.1) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(100, 200, 255, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 60% 20%, rgba(64, 158, 255, 0.12) 1px, transparent 1px);
  background-size: 60px 60px, 80px 80px, 100px 100px, 70px 70px;
  pointer-events: none;
  animation: particleFloat 20s linear infinite;
}

@keyframes particleFloat {
  0% {
    background-position: 0 0, 0 0, 0 0, 0 0;
  }
  100% {
    background-position: 100px 100px, 150px 150px, 200px 200px, 80px 80px;
  }
}

.login_box {
  width: 450px;
  min-height: 300px;
  background-color: #fff;
  backdrop-filter: blur(10px);
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .avatar_box {
    height: 130px;
    width: 130px;
    border: 1px solid #eee;
    border-radius: 50%;
    padding: 10px;
    box-shadow: 0 0 10px #ddd;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #eee;
    }
  }
}

.login_form {
  position: absolute;
  bottom: 25px;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}

.btns {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0;
}

.icp-footer {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  text-align: center;
}

.icp-footer a {
  color: #909399;
  font-size: 12px;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-footer a:hover {
  color: #409EFF;
  text-decoration: underline;
}
</style>
